import {ModalLazyLoader} from 'components/ModalLazyLoader';
import {useAgeModal} from 'core/hooks/useAgeModal';
import {Modal} from 'modules/modals/components/Modal';
import {MODALS} from 'modules/modals/constants';
import dynamic from 'next/dynamic';
import React, {FC, PropsWithChildren, useEffect, useState} from 'react';
import {CommonLayoutContext} from 'layouts/CommonLayout/context';
import {COOKIES_POLICY_ROUTE} from 'core/modules/routing/constants';
import {usePathname} from 'next/navigation';
import YandexMetrika from 'components/YandexMetrika';
import {usePageViewGtag} from 'hooks/analytics/gtag/usePageViewGtag';
import {useSyncCartFlocktory} from 'hooks/analytics/flocktory/flocktoryCartEvents';
import {FilterPickupTodayButtonProvider} from 'plugins/modules/filter/provider/FilterPickupTodayButtonProvider';
import {FilterPickupModalProvider} from 'plugins/modules/filter/provider/FilterPickupModalProvider';
import {useInitAbExpressOrder} from 'modules/ab-tests/hooks';

const AgeConfirmModal = dynamic(() => import('modules/modals/components/AgeConfirmModal'), {
    loading: () => <ModalLazyLoader />,
});

const ProductPickUpModal = dynamic(() => import('modules/products/components/PickUpModal'), {
    loading: () => <ModalLazyLoader />,
});

export const CommonLayout: FC<PropsWithChildren> = ({children}) => {
    usePageViewGtag();
    useSyncCartFlocktory();
    useInitAbExpressOrder();

    const [upButtonClassName, setUpButtonClassName] = useState<string>();
    const {handleShowAgeConfirm} = useAgeModal();

    const pathname = usePathname();

    useEffect(() => {
        handleShowAgeConfirm();
    }, [handleShowAgeConfirm]);

    return (
        <CommonLayoutContext.Provider value={{setUpButtonClassName, upButtonClassName}}>
            <FilterPickupTodayButtonProvider>
                {children}
                {pathname !== COOKIES_POLICY_ROUTE && (
                    <Modal name={MODALS.AGE_CONFIRM.name} willMount={true}>
                        <AgeConfirmModal />
                    </Modal>
                )}
                <Modal name={MODALS.EXPRESS_ORDER.name} willMount={true}>
                    <FilterPickupModalProvider>
                        <ProductPickUpModal />
                    </FilterPickupModalProvider>
                </Modal>
                <YandexMetrika />
            </FilterPickupTodayButtonProvider>
        </CommonLayoutContext.Provider>
    );
};
